module.exports = __webpack_public_path__ + "static/media/Products (14).fbb4dfcb.jfif";